export enum QUESTION_TYPE {
    TRUE_FALSE = 1,
    MULTIPLE_CHOICE = 2,
    MULTIPLE_SELECTION = 3,
    FIB = 4,
    LONG_ESSAY = 5,
    MATH = 6,
    MM_DRAG_DROP = 7,
    MATCHING = 8,
    MATCHING_QUESTION_IMAGE = 9,
    SIMPLE_MATH = 10,
    MATRIX_LABEL = 11,
    PROFIT_LOSS = 12,
    MATRIX_MULTIPLE_INPUT = 13,
    MATRIX_SINGLE_INPUT = 14,
    MATRIX_NOTE = 15,
    MATRIX_SECTION = 16,
    MATRIX_VARIANT = 17,
    DUAL_RESPONSE = 18,
    ESSAY_RESPONSE = 19,
    SCORM = 21,
    ORAL = 22,
    CONTEXTUAL_WORDS = 23,
    EMAIL = 1023,
    TAB = 1024,
    IMAGE_MAP = 1025,
    CUSTOM = 1026,
    CARROUSEL_ORAL = 1027,
    MM_FIB = 1028,
    HIGHLIGHT_QUESTION = 1029,
    CARROUSEL = 1030,
    GENERAL = 1031,
    UPLOAD = 1032
}